import React from 'react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Button } from '../ui/button';
import { Plus, X } from 'lucide-react';
import SimpleTooltip from '../SimpleTooltip';

export function SectionEditor({ sections, onChange }) {
  const addSection = () => {
    onChange([...sections, { id: Date.now(), title: '', timestamp: 0, description: '' }]);
  };
  const removeSection = (i) => onChange(sections.filter((_, idx) => idx !== i));
  const updateSection = (i, field, value) => {
    const updated = [...sections];
    updated[i] = { ...updated[i], [field]: value };
    onChange(updated);
  };

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <Label className="text-gray-300">Sections</Label>
        <Button type="button" size="sm" variant="outline" className="h-7 text-xs border-gray-600 text-gray-300 hover:bg-gray-700" onClick={addSection}>
          <Plus className="w-3 h-3 mr-1" /> Add Section
        </Button>
      </div>
      {sections.map((s, i) => (
        <div key={s.id || `section-${i}`} className="flex gap-2 items-start bg-gray-800 rounded p-2">
          <span className="text-xs text-gray-500 font-mono mt-2 w-5 shrink-0">{i + 1}</span>
          <div className="flex-1 space-y-1">
            <Input placeholder="Section title" value={s.title} onChange={(e) => updateSection(i, 'title', e.target.value)} className="h-7 text-xs bg-gray-700 border-gray-600 text-white" />
            <Input placeholder="Description" value={s.description} onChange={(e) => updateSection(i, 'description', e.target.value)} className="h-7 text-xs bg-gray-700 border-gray-600 text-white" />
          </div>
          <Input type="number" placeholder="t(s)" value={s.timestamp} onChange={(e) => updateSection(i, 'timestamp', parseInt(e.target.value) || 0)} className="h-7 w-16 text-xs bg-gray-700 border-gray-600 text-white mt-0" />
          <SimpleTooltip content="Remove section">
            <Button type="button" variant="ghost" size="icon" aria-label="Remove section" className="h-7 w-7 text-red-400 hover:text-red-300 shrink-0 mt-0" onClick={() => removeSection(i)}>
              <X className="w-3 h-3" />
            </Button>
          </SimpleTooltip>
        </div>
      ))}
      {sections.length === 0 && <p className="text-xs text-gray-500 italic">No sections yet</p>}
    </div>
  );
}
